module.exports = __webpack_public_path__ + "static/media/settings-divider.bd8c38e1.png";